import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import PageTooltip from "../components/Tooltip"
import { clearBaseLineStore } from "../hooks/baseline"
import { getPofile, updateReminders, storeProfile } from '../hooks/auth'
import { Container, Form, Button } from 'react-bootstrap'
import Time from '../components/Time'
import { useNavigate } from 'react-router-dom'

const mapStateToProps = (state) => {
  return {
    baseline: state.baseline,
    auth: state.auth
  }
}

const mapDispatchToProps = dispatch => ({
  clearBaseLineStore: () => dispatch(clearBaseLineStore()),
  getPofile: () => dispatch(getPofile()),
  storeProfile: () => dispatch(storeProfile()),
  updateReminders: (data) => dispatch(updateReminders(data))
});

const getScoreLevel = (base, score) => {
  var classColor = true
  if (base !== null && base > score) {
    classColor = false
  }
  return classColor
}

const getColour = (base, score, set_base) => {
  var className = "alertness-test-base-marks-register"
  if (set_base) {
    return className
  }
  if (score > base) {
    className = "alertness-test-result-green"
  } else if (base == score) {
    className = "alertness-test-base-marks-equal"
  } else {
    className = "alertness-test-risk-marks"
  }
  return className
}

const NavigateOnStateChange = ({ shouldNavigate, to }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (shouldNavigate) {
      navigate(to);
    }
  }, [shouldNavigate, navigate, to]);

  return null;
};


class AlertnessTestResult extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      score: null,
      baseline_score: null,

      reminder_by_phone: false,
      reminder_by_email: false,
      alert_monday: false,
      alert_tuesday: false,
      alert_wednesday: false,
      alert_thursday: false,
      alert_friday: false,
      alert_saturday: false,
      alert_sunday: false,
      alert_time: null,
      update: true,
      shouldNavigate: false,
      path: null
    };

  }

  componentDidMount() {
    if (this.props.baseline.score != null) {
      this.setState({
        score: this.props.baseline.score,
        baseline_score: this.props.baseline.baseline_score
      })
    } else {
      this.setState({
        score: this.props.baseline.score,
        shouldNavigate: true,
        path: this.props.auth.baseline ? "/dashboard" : "/alertness"
      })
      this.props.clearBaseLineStore()
    }
    if (this.props.auth.access_token !== null) {
      this.props.getPofile()
    }
  }


  componentDidUpdate = () => {
    if (this.props.auth.profile != null) {
      var profile = this.props.auth.profile
      this.props.storeProfile()
      this.setState({
        reminder_by_phone: profile.reminder_by_phone,
        reminder_by_email: profile.reminder_by_email,
        alert_monday: profile.alert_monday,
        alert_tuesday: profile.alert_tuesday,
        alert_wednesday: profile.alert_wednesday,
        alert_thursday: profile.alert_thursday,
        alert_friday: profile.alert_friday,
        alert_saturday: profile.alert_saturday,
        alert_sunday: profile.alert_sunday,
        alert_time: profile.alert_time != null ? profile.alert_time : "12:00",
        update: true
      })
    }
  }

  timeChange = (time) => {
    this.setState({ "alert_time": time, update: false })
  }

  handleChecked = (event) => {
    this.setState({ [event.target.name]: event.target.checked, update: false })
  }

  updateReminders = () => {
    this.props.updateReminders({
      reminder_by_phone: this.state.reminder_by_phone ? 1 : 0,
      reminder_by_email: this.state.reminder_by_email ? 1 : 0,
      alert_monday: this.state.alert_monday ? 1 : 0,
      alert_tuesday: this.state.alert_tuesday ? 1 : 0,
      alert_wednesday: this.state.alert_wednesday ? 1 : 0,
      alert_thursday: this.state.alert_thursday ? 1 : 0,
      alert_friday: this.state.alert_friday ? 1 : 0,
      alert_saturday: this.state.alert_saturday ? 1 : 0,
      alert_sunday: this.state.alert_sunday ? 1 : 0,
      alert_time: this.state.alert_time
    })
  }

  render() {
    return <Fragment>
      <div className="color-body">
        <NavbarComp bgblue={true} access_token={true} />
        <div className="page-sections">
          <div className='alertness-test-result-wrap'>
            <Container>
              <div className='alertness-test-result-contents'>
                <h2 className='main-title-style'>ALL DONE</h2>
                {this.state.baseline_score != null && !this.props.baseline.set_base ?
                  <div className='cas-score'>
                    <p>Current CAS baseline score:</p>
                    <span>{this.state.baseline_score}</span>
                  </div> : null}
                <PageTooltip
                  title={!this.props.baseline.set_base ? "Your Cognitive Accuracy Score (CAS) today is:" : "Your baseline Cognitive Accuracy Score (CAS) is:"}
                  text="Your CAS is a function of speed and accuracy. Try to complete as many correct trials."
                />

                {getScoreLevel(this.state.baseline_score, this.state.score) ?
                  <div className={'alertness-test-result ' + (getColour(this.state.baseline_score, this.state.score, this.props.baseline.set_base))}>{this.state.score}</div> :
                  <div className='risk-score'>
                    <div className={'alertness-test-result ' + (getColour(this.state.baseline_score, this.state.score, this.props.baseline.set_base))}>{this.state.score}</div>
                    <h4>You’re at risk of low alertness today</h4>
                  </div>}

                {!this.props.baseline.set_base ? <>
                  <p>Tiredness and fatigue affect our ability to operate safely and productively. If you are having a low alertness day, please be mindful of the extra risks and take precautions.</p>
                  <p>Precautions could include changing task, taking a break, having a short nap, asking for a second opinion, asking for extra supervision on dangerous tasks, speaking to your supervisor or other tried and tested precautions.</p>
                </> : null}
                <p>Remember to come back at the start of your next shift to assess your alertness.</p>

                {this.props.auth.user != null ?
                  <div className='alertness-test-reminder'>
                    <div>
                      <h2 className='main-title-style'>SET A REMINDER</h2>
                      <span className='reminder-span'>Make it easy to participate. Set a reminder for your next shift or series of shifts.</span>
                    </div>
                    <div>

                      <div className='phone-mail-reminder'>
                        <div key={`default-checkbox`} className="form-checkboxes">
                          <Form.Check onClick={this.handleChecked} checked={this.state.reminder_by_phone} name='reminder_by_phone' type="checkbox" id={`text-phone`} label={`Text by phone`} />
                          <Form.Check onClick={this.handleChecked} checked={this.state.reminder_by_email} name='reminder_by_email' type="checkbox" id={`email`} label={`Email`} />
                        </div>
                      </div>
                      <div className='alert-time-reminders'>
                        <Form.Group controlId="formGroupTime">
                          <Time time={24} label="Alert time" user_answers={this.state.alert_time} handleAnswerChange={this.timeChange} />
                        </Form.Group>
                      </div>
                      <div className='reminder-days'>
                        <div key={`default-checkbox`} className="form-checkboxes">
                          <Form.Check onClick={this.handleChecked} checked={this.state.alert_monday} name='alert_monday' type="checkbox" id={`monday`} label={`Monday`} />
                          <Form.Check onClick={this.handleChecked} checked={this.state.alert_tuesday} name='alert_tuesday' type="checkbox" id={`tuesday`} label={`Tuesday`} />
                          <Form.Check onClick={this.handleChecked} checked={this.state.alert_wednesday} name='alert_wednesday' type="checkbox" id={`wendesday`} label={`Wendesday`} />
                          <Form.Check onClick={this.handleChecked} checked={this.state.alert_thursday} name='alert_thursday' type="checkbox" id={`thursday`} label={`Thursday`} />
                          <Form.Check onClick={this.handleChecked} checked={this.state.alert_friday} name='alert_friday' type="checkbox" id={`friday`} label={`Friday`} />
                          <Form.Check onClick={this.handleChecked} checked={this.state.alert_saturday} name='alert_saturday' type="checkbox" id={`saturday`} label={`Saturday`} />
                          <Form.Check onClick={this.handleChecked} checked={this.state.alert_sunday} name='alert_sunday' type="checkbox" id={`sunday`} label={`Sunday`} />
                        </div>
                      </div>
                      <Button onClick={this.updateReminders} type="submit">Save</Button>
                    </div>
                  </div> : null}
              </div>
            </Container>
          </div>
        </div>
      </div>
      <NavigateOnStateChange shouldNavigate={this.state.shouldNavigate} to={this.state.path} />
    </Fragment>
  }
}

AlertnessTestResult.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertnessTestResult);
